import { render, staticRenderFns } from "./metalPrice.vue?vue&type=template&id=53a8a254&scoped=true&"
import script from "./metalPrice.vue?vue&type=script&setup=true&lang=js&"
export * from "./metalPrice.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./metalPrice.vue?vue&type=style&index=0&id=53a8a254&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a8a254",
  null
  
)

export default component.exports